import React, { useState } from 'react';

const TopUpModal = ({ onClose, onTopUp, currentBalance }) => {
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [loading, setLoading] = useState(false);

  const predefinedAmounts = [10, 25, 50, 100];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const topUpAmount = parseFloat(amount);
    if (!topUpAmount || topUpAmount <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    if (topUpAmount > 1000) {
      alert('Maximum top-up amount is $1000');
      return;
    }

    setLoading(true);
    try {
      await onTopUp(topUpAmount, paymentMethod);
    } catch (error) {
      console.error('Top-up failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePredefinedAmount = (predefinedAmount) => {
    setAmount(predefinedAmount.toString());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">💳 Top Up Balance</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="current-balance">
          <div>
            <strong>Current Balance: ${currentBalance.toFixed(2)}</strong>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="topup-form">
          <div className="form-group">
            <label className="form-label">Amount to Add</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              min="1"
              max="1000"
              step="0.01"
              className="amount-input"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Quick Amounts</label>
            <div className="quick-amounts">
              {predefinedAmounts.map(predefinedAmount => (
                <button
                  key={predefinedAmount}
                  type="button"
                  className="quick-amount-btn"
                  onClick={() => handlePredefinedAmount(predefinedAmount)}
                  style={{
                    background: amount === predefinedAmount.toString() 
                      ? 'var(--tg-theme-button-color, #007bff)' 
                      : 'var(--tg-theme-secondary-bg-color, #f8f9fa)',
                    color: amount === predefinedAmount.toString() 
                      ? 'var(--tg-theme-button-text-color, #ffffff)' 
                      : 'var(--tg-theme-text-color, #000)',
                    border: '1px solid var(--tg-theme-hint-color, #ddd)',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    margin: '4px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  ${predefinedAmount}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Payment Method</label>
            <div className="payment-methods">
              <div className="payment-method">
                <input
                  type="radio"
                  id="card"
                  name="paymentMethod"
                  value="card"
                  checked={paymentMethod === 'card'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label htmlFor="card">💳 Credit/Debit Card</label>
              </div>
              <div className="payment-method">
                <input
                  type="radio"
                  id="paypal"
                  name="paymentMethod"
                  value="paypal"
                  checked={paymentMethod === 'paypal'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label htmlFor="paypal">🏦 PayPal</label>
              </div>
              <div className="payment-method">
                <input
                  type="radio"
                  id="crypto"
                  name="paymentMethod"
                  value="crypto"
                  checked={paymentMethod === 'crypto'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label htmlFor="crypto">₿ Cryptocurrency</label>
              </div>
              <div className="payment-method">
                <input
                  type="radio"
                  id="stars"
                  name="paymentMethod"
                  value="telegram-stars"
                  checked={paymentMethod === 'telegram-stars'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label htmlFor="stars">⭐ Telegram Stars</label>
              </div>
            </div>
          </div>

          {amount && (
            <div className="preview" style={{
              background: 'var(--tg-theme-secondary-bg-color, #f8f9fa)',
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '16px'
            }}>
              <strong>
                New Balance: ${(currentBalance + parseFloat(amount || 0)).toFixed(2)}
              </strong>
            </div>
          )}

          <button
            type="submit"
            className="topup-submit-btn"
            disabled={loading || !amount}
          >
            {loading ? '⏳ Processing...' : `💸 Add $${amount || '0'}`}
          </button>
        </form>

        <div style={{ 
          marginTop: '16px', 
          fontSize: '12px', 
          color: 'var(--tg-theme-hint-color, #666)',
          textAlign: 'center'
        }}>
          💡 This is a demo app. No real payment will be processed.
        </div>
      </div>
    </div>
  );
};

export default TopUpModal;